import { ComponentStyles } from "types/common";

const CONTAINER_BORDER_RADIUS = 2;
const CONTAINER_PADDING = 0.5;

export const styles: ComponentStyles = {
  toolbarContainer: {
    position: "absolute",
    left: 4,
    zIndex: 100,
    // backgroundColor: "#fff",
    borderRadius: CONTAINER_BORDER_RADIUS + 2 * CONTAINER_PADDING,
    padding: CONTAINER_PADDING,
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
    gap: 1,
    minHeight: "30%",
    webkitUserSelect: "none" /* Safari */,
    userSelect: "none" /* Standard syntax */,
  },
  toolbarminiWrapper: {
    backgroundColor: "#272727",
    zIndex: 100,
    borderRadius: CONTAINER_BORDER_RADIUS + CONTAINER_PADDING,
    gap: 0.5,
    padding: CONTAINER_PADDING,
  },
  refMeasurementsInformationBox: {
    position: "absolute",
    zIndex: 100,
    pointerEvents: "none",
    userSelect: "none",
    // left: "120%",
    background: "background.paper",
  },
  refMeasurementsInformationBoxText: {
    fontSize: "0.2rem",
  },
};

export const cursorStyleOnReferenceMeasurementModeButton = (
  disabled: boolean
) => {
  return {
    cursor: disabled ? "not-allowed" : "pointer",
  };
};

export const commonStyles = (fullscreen: boolean, isActive: boolean) => ({
  backgroundColor: isActive ? "royalblue" : "transparent",
  borderRadius: CONTAINER_BORDER_RADIUS,
  zIndex: 100,
  cursor: "pointer",
  minWidth: fullscreen
    ? {
        xs: "2rem",
        sm: "2rem",
        md: "2.2rem",
      }
    : {
        xs: "2rem",
        sm: "2rem",
        md: "2.2rem",
      },
  aspectRatio: "1 / 1",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  "&:hover": {
    backgroundColor: isActive ? "royalblue" : "background.paper",
  },
});

export const miniCommonStyles = (
  fullscreen: boolean,
  isActive: boolean,
  show: boolean,
  isDanger = false
) => ({
  borderRadius: "100%",
  width: fullscreen
    ? {
        xs: "2.2rem",
        sm: "2rem",
        md: "2rem",
      }
    : {
        xs: "2.2rem",
        sm: "2rem",
        md: "2rem",
      },
  aspectRatio: "1/1",
  display: "flex",
  zIndex: 100,
  justifyContent: "center",
  alignItems: "center",
  border: "solid 2px #4440",
  transition: "all 0.3s ease",
  transformOrigin: "center",
  // scale: show ? 1 : 0,
  opacity: show ? 1 : 0,
  transform: show ? "translateX(0) scale(1)" : "translateX(-100%) scale(0)",
  backgroundColor: isActive
    ? isDanger
      ? "red"
      : "royalblue"
    : "background.paper",
  cursor: "pointer",
  "&:hover": {
    border: "solid 2px #444",
    backgroundColor: isActive
      ? isDanger
        ? "red"
        : "royalblue"
      : "common.black",
  },
});
